import React, { useState, useEffect } from 'react';
import FloatingAppBar from './appBar'; // Adjust path as needed
import FloatingVerticalMenu from './FloatingVerticalMenu'; // Adjust path as needed
import EDashboard from './dashboardItems/eDashboard'; // Import the new EDashboard component
import ETasks from './eTasks/eTasks'; // Import the new ETasks component
import ESalary from './eSalary/eSalary'; // Import the new ESalary component
import EAttendance from './eLeaveManagement/eAttendance';
import { useLocation } from 'react-router-dom';

const EmployeeDashboard = () => {
  
  const [selectedMenu, setSelectedMenu] = useState(() => {
    // Initialize from sessionStorage or default to 'dashboard'
    return sessionStorage.getItem('selectedMenu') || 'dashboard';
  });

  const location = useLocation();
  const { user } = location.state || {};

  // Store the selected menu item in sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  const renderContent = () => {
    switch (selectedMenu) {
      case 'dashboard':
        return <EDashboard user={user} />;
      case 'leaveManagement':
        return <EAttendance user={user}/>;
      case 'tasks':
        return <ETasks user={user} />;
      case 'salary':
        return <ESalary user={user} />;
      default:
        return <EDashboard user={user} />;
    }
  };

  return (
    <div>
      <FloatingAppBar user={user} />
      <div style={{ display: 'flex', marginTop: '35px' }}>
        <FloatingVerticalMenu 
          selectedMenu={selectedMenu} // Pass the selectedMenu state
          onMenuSelect={setSelectedMenu} // Pass the setter to handle selection
        />
        <div style={{ marginLeft: '100px', padding: '20px', flex: 1 }}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;
